import React, { FC } from "react";
import { makeStyles } from "@material-ui/core";

const CSSVariables: FC = () => {
    const useStyle = makeStyles((theme) => ({
        "@global": {
            ":root": {
                "--formHeaderV": "0px",
                "--formHeaderH": "0px",
                "--formBodyV": "0px",
                "--formBodyH": "0px",
                // [theme.breakpoints.up("sm")]: {
                //  "--formBody": "16px",
                // },
                // [theme.breakpoints.up("md")]: {
                //  "--formBody": "16px",
                // },
                // [theme.breakpoints.up("lg")]: {
                //  "--formBody": "16px",
                // },
            },
        },
    }));

    useStyle();

    return <></>;
};

export default CSSVariables;
